import React, { memo } from 'react'

import { number, oneOf } from 'prop-types'

import CheckIcon from '../CheckIcon/CheckIcon'

const VARIANT_CONFIG = {
  subscription: {
    listClass: 'usage-modal__bullets',
    itemClass: 'usage-modal__bullet',
    iconSize: 'small',
  },
  upgrade: {
    listClass: 'usage-modal__upgrade-card-bullets',
    itemClass: 'usage-modal__upgrade-card-bullet',
    iconSize: 'small',
  },
}

// Subscription benefit list shared by the 3D Studio usage modal and the AI subscription landing
// waitlist modal. monthlyModels is injected by the caller (the studio reads it from its store, the
// landing passes a literal) so the component stays store-agnostic.
function SubscriptionBullets({ variant, monthlyModels = null }) {
  const { listClass, itemClass, iconSize } = VARIANT_CONFIG[variant]

  return (
    <ul className={listClass}>
      {monthlyModels != null && (
        <li className={itemClass}>
          <CheckIcon size={iconSize} />
          <span className="cgt-body-base">
            {`${monthlyModels} CGTrader AI generations or Marketplace downloads`}
          </span>
        </li>
      )}
      <li className={itemClass}>
        <CheckIcon size={iconSize} />
        <span className="cgt-body-base">
          Edit and enhance your own or purchased 3D models
        </span>
      </li>
      <li className={itemClass}>
        <CheckIcon size={iconSize} />
        <span className="cgt-body-base">All top AI engines included: Tripo, Hunyuan, Meshy</span>
      </li>
    </ul>
  )
}

SubscriptionBullets.propTypes = {
  variant: oneOf(['subscription', 'upgrade']).isRequired,
  monthlyModels: number,
}

export default memo(SubscriptionBullets)
